import http from '@/utils/request';

const apis = {
  getGoodsInfoList( keyWord , pageNum , pageSize ,typeId) { // 获取硬件列表
    return http.get({
        url: '/pc/goodsInfo/getGoodsInfoList',
        data: {
          keyWord,
          pageNum,
          pageSize,
          typeId,
        }
    })
  },
  getGoodsType() { // 获取商品分类
    return http.get({
        url: '/pc/getGoodsType/getGoodsTypeNum',
        data: {}
    })
  },
  getGoodsInfo( id ) { // 获取商品详情
    return http.get({
        url: '/pc/goodsInfo/getGoodsInfo',
        data: {
          id
        }
    })
  },
  getGoodsReviewInfo( id ) { // 硬件评测详情
    return http.get({
        url: '/pc/goodsReview/getGoodsReviewInfo',
        data: {
          id
        }
    })
  },
  getGoodsParameterInfo( id ) { // 硬件规格参数
    return http.get({
        url: '/pc/goodsParameter/getGoodsParameterInfo',
        data: {
          id
        }
    })
  },
  getHaveGoodsReviewList( pageNum  , pageSize ) { // 获取最新测评信息的硬件产品
    return http.get({
        url: '/pc/goodsInfo/getHaveGoodsReviewList',
        data: {
          pageNum: pageNum,
          pageSize: pageSize
        }
    })
  },
  getGoodsUpload( id ) { // 获取文件下载地址
    return http.get({
        url: '/pc/goodsUpload/getGoodsUpload',
        data: {
          goods_info_id: id
        }
    })
  },
  getBrandList( pageNum  , pageSize) { // 获取品牌馆数据
    return http.get({
        url: '/pc/goodsInfo/getBrandList',
        data: {
          pageNum: pageNum,
          pageSize: pageSize
        }
    })
  },
  getnewsList( pageNum  , pageSize) { // 获取品牌馆数据
    return http.getter({
        url: '/app/user/create',
       
        data: {
          pageNum: pageNum,
          pageSize: pageSize
        }
    })
  },
  getSysNews( id) { // 获取品牌馆数据
    return http.getter({
        url: '/sysNews/getSysNews',
        data: {
          id: id,
        }
    })
  },
  
}
export default apis